"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitRechargeStorefrontSdk = void 0;
var storefront_client_1 = require("@rechargeapps/storefront-client");
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_1 = require("react");
var RECHARGE_STOREFRONT_SESSION_COOKIE = 'recharge_storefront_session';
// initialization only needs to take place once, so we put this in the module scope
var rechargeStorefrontClientInitialized = false;
/** Manages the initialization of the recharge storefront sdk library and the setup of a storefront session. */
var useInitRechargeStorefrontSdk = function () {
    var storefrontAccessToken = process.env.RECHARGE_STOREFRONT_ACCESS_TOKEN;
    if (!storefrontAccessToken)
        throw new Error('Missing RECHARGE_STOREFRONT_ACCESS_TOKEN');
    var _a = __read((0, react_1.useState)(), 2), session = _a[0], setSession = _a[1];
    // initialize the recharge sdk to take advantage of its login retry mechanism by which we can fetch a new session
    // and then store that new session in memory and in the cookie
    var storeIdentifier = 'hb-launched.myshopify.com';
    if (!rechargeStorefrontClientInitialized) {
        (0, storefront_client_1.initRecharge)({
            storeIdentifier: storeIdentifier,
            storefrontAccessToken: storefrontAccessToken,
            loginRetryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
                var newSession;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, storefront_client_1.loginShopifyAppProxy)()];
                        case 1:
                            newSession = _a.sent();
                            js_cookie_1.default.set(RECHARGE_STOREFRONT_SESSION_COOKIE, JSON.stringify(newSession));
                            // this will trigger a rerender of this hook, which will eventually set up this hook to return the session
                            setSession(newSession);
                            return [2 /*return*/, session];
                    }
                });
            }); },
        });
        rechargeStorefrontClientInitialized = true;
    }
    // if we have the session already in memory, use that
    if (session)
        return { initialized: rechargeStorefrontClientInitialized, session: session };
    // if we have the session already in a cookie, use that
    var cookieSession = js_cookie_1.default.get(RECHARGE_STOREFRONT_SESSION_COOKIE);
    if (cookieSession) {
        try {
            var newSession = JSON.parse(cookieSession);
            if (!('apiToken' in newSession))
                throw new Error('Invalid cookie');
            var typedSession = newSession;
            return { initialized: rechargeStorefrontClientInitialized, session: typedSession };
        }
        catch (error) {
            console.error('Recharge session cookie issue', error);
            // don't return; let initRecharge regenerate the session and re-set this cookie
        }
    }
    // if we didn't have the session in memory or in a cookie, create a new recharge session
    (0, storefront_client_1.loginShopifyAppProxy)().then(function (newSession) {
        js_cookie_1.default.set(RECHARGE_STOREFRONT_SESSION_COOKIE, JSON.stringify(newSession));
        // this will trigger a rerender of this hook, which will eventually set up this hook to return the session
        setSession(newSession);
    });
    // Even if we don't have a valid session yet, we always return whether or not the storefront client is initialized
    // so that callers who don't actually need a session don't have to wait for the session to be ready.
    return { initialized: rechargeStorefrontClientInitialized, session: undefined };
};
exports.useInitRechargeStorefrontSdk = useInitRechargeStorefrontSdk;
